import { Icon } from "./Icon.jsx";
import { daysToDiwali } from "../config/seasons.js";

// ─── SEASON BANNER (Discover home, just under the main banner) ───────────────────────────────────────────────
// A slimmer banner for the current season (festive right now). It opens the "Seasonal" product list: real products
// from across the marketplace that suit the occasion. In festive season it shows a live "Diwali in N days" chip.
// Seasons without a photo get a soft abstract motif instead.
const Motif = ({ tint }) => (
  <svg viewBox="0 0 200 200" aria-hidden="true" style={{ position: "absolute", right: -30, top: -30, height: "150%", opacity: 0.35, color: "#fff" }}>
    {[90, 70, 50, 30].map((r) => <circle key={r} cx="100" cy="100" r={r} fill="none" stroke="currentColor" strokeWidth="2" />)}
    <circle cx="100" cy="100" r="10" fill="currentColor" />
  </svg>
);

export function SeasonBanner({ season, count = 0, mobile = false, onOpen, now = new Date() }) {
  if (!season) return null;
  const diwali = season.id === "festive" ? daysToDiwali(now) : null;
  const photo = season.image;
  return (
    <section aria-label={season.label}
      style={{ position: "relative", overflow: "visible", borderRadius: 4, border: mobile ? "none" : "1px solid var(--border)", minHeight: mobile ? 240 : 260, display: "flex", alignItems: "center", background: "var(--teal)" }}>
      {/* the season's photo: framed, on the left, hanging over the banner's top and bottom edges */}
      {photo
        ? <img src={photo} alt="" style={mobile
            ? { position: "absolute", left: 16, top: -18, width: "34%", height: "calc(100% + 36px)", objectFit: "cover", borderRadius: 4, border: "5px solid var(--offwhite)" }
            : { position: "absolute", left: 72, top: -32, width: "34%", height: "calc(100% + 64px)", objectFit: "cover", borderRadius: 4, border: "8px solid var(--offwhite)" }} />
        : <Motif tint={season.tint} />}
      <div style={{ position: "relative", marginLeft: "auto", color: "#fff", width: mobile ? "56%" : "52%", minWidth: mobile ? 0 : 320, padding: mobile ? "34px 18px 38px 8px" : "36px 72px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
          <span style={{ fontSize: mobile ? 12 : 13, fontWeight: 700, color: "var(--ink)", background: "rgba(255,255,255,0.9)", borderRadius: 4, padding: "2px 8px" }}>{season.eyebrow}</span>
          {diwali != null && <span style={{ fontSize: mobile ? 12 : 13, fontWeight: 600 }}>{diwali === 0 ? "Happy Diwali!" : `Diwali ${diwali === 1 ? "is tomorrow" : `in ${diwali} days`}`}</span>}
        </div>
        {mobile
          ? <div className="serif" style={{ fontSize: 30, marginTop: 14 }}>{season.title}</div>
          : <h2 className="serif" style={{ margin: "22px 0 0", fontSize: "clamp(34px, 3.6vw, 52px)" }}>{season.title}</h2>}
        {!mobile && <p style={{ margin: "16px 0 0", fontSize: 15, lineHeight: 1.45, maxWidth: 420 }}>{season.sub}</p>}
        <button className="btn-pink" onClick={onOpen} style={{ marginTop: mobile ? 22 : 28, height: mobile ? 36 : 42, padding: mobile ? "0 14px" : "0 22px", fontSize: mobile ? 13 : 14, fontWeight: 700, display: "inline-flex", alignItems: "center", gap: 8, background: "var(--butter)", color: "var(--ink)", borderColor: "var(--butter)" }}>
          {season.cta}{count > 0 ? ` · ${count}` : ""}<Icon n="forward" size={16} />
        </button>
      </div>
      {season.credit && (
        <a href={season.credit.href} target="_blank" rel="noreferrer noopener" style={{ position: "absolute", right: 8, bottom: 5, fontSize: 10, color: "rgba(255,255,255,0.85)", textShadow: "0 1px 3px rgba(0,0,0,0.6)", textDecoration: "none" }}>{season.credit.text}</a>
      )}
    </section>
  );
}
